import { useMemo } from "react";
import useCustomerDetails from "../data/useCustomerDetails";
import { FeatureStatus } from "../models/Customer";

export const useFeatureFlag = (flagName: string) => {
  const { features } = useCustomerDetails();

  return useMemo(
    () => !!features.data?.data?.some((feature) => feature.name === flagName),
    [features.data, flagName]
  );
};

export const CheckFeatureFlag = useFeatureFlag;

/**
 * Unlike useFeatureFlag (which only tests presence), this returns true only when the
 * named feature exists AND its status is Enabled.
 */
export const useFeatureEnabled = (flagName: string) => {
  const { features } = useCustomerDetails();

  return useMemo(
    () =>
      !!features.data?.data?.some(
        (feature) => feature.name === flagName && feature.status === FeatureStatus.Enabled
      ),
    [features.data, flagName]
  );
};
